import React from 'react';
import PropTypes from 'prop-types';

import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';

import { useTheme } from '@material-ui/core/styles';

import IItems from '@meronex/icons/fi/FiBox';
import MdClose from '@meronex/icons/md/MdClose';
import Filter from '../../../common/Filter';
import ItemTypesList from './ItemTypesList';

function ItemTypesDialog(props) {
  const {
    open,
    onClose,
    store,
    onAdd,
    storeItems,
    itemTypes,
    onItemTypeDelete,
    onItemTypeCreate,
    onItemTypeUpdate,
    enableAddToStore,
    permissions,
  } = props;

  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [filterText, setFilterText] = React.useState('');
  const accentColor = isDark ? 'rgba(99,102,241,0.8)' : '#6366f1';

  const _onClose = () => {
    onClose();
    setFilterText('');
  };

  const count = Array.isArray(itemTypes) ? itemTypes.length : 0;

  return (
    <Dialog
      className={'fullScreenMobile'}
      open={open}
      onClose={_onClose}
      maxWidth="sm"
      fullWidth>
      {/* Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '16px 20px',
        borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.08)' : '#f1f5f9'}`,
      }}>
        <div style={{
          width: '36px',
          height: '36px',
          borderRadius: '10px',
          backgroundColor: isDark ? 'rgba(99,102,241,0.12)' : '#eef2ff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: accentColor,
          flexShrink: 0,
        }}>
          <IItems size={18} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{
            fontSize: '15px',
            fontWeight: 600,
            color: isDark ? '#e2e8f0' : '#1e293b',
          }}>
            Item Types
          </div>
          {count > 0 && (
            <div style={{ fontSize: '12px', color: isDark ? 'rgba(255,255,255,0.4)' : '#94a3b8' }}>
              {count} types available
            </div>
          )}
        </div>
        <div
          onClick={_onClose}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            borderRadius: '8px',
            cursor: 'pointer',
            color: isDark ? '#94a3b8' : '#64748b',
            flexShrink: 0,
            fontSize: '20px',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}>
          <MdClose />
        </div>
      </div>
      {/* Filter */}
      <div style={{ padding: '12px 20px', borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.06)' : '#f8fafc'}` }}>
        <Filter
          placeholder="Search item types..."
          onFilter={(v) => setFilterText(v)}
        />
      </div>
      <DialogContent style={{ padding: '0' }}>
        <ItemTypesList
          store={store}
          filterText={filterText}
          onItemTypeDelete={onItemTypeDelete}
          onItemTypeCreate={onItemTypeCreate}
          onItemTypeUpdate={() => onItemTypeUpdate()}
          onAddToStore={() => onAdd()}
          enableAddToStore={enableAddToStore}
          itemTypes={itemTypes}
          storeItems={storeItems}
          permissions={permissions}
        />
      </DialogContent>
    </Dialog>
  );
}

ItemTypesDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  store: PropTypes.object,
  onAdd: PropTypes.func,
  itemTypes: PropTypes.array,
  onItemTypeDelete: PropTypes.func,
  onItemTypeCreate: PropTypes.func,
  onItemTypeUpdate: PropTypes.func,
  enableAddToStore: PropTypes.bool,
};
ItemTypesDialog.defaultProps = {
  enableAddToStore: true,
};

export default ItemTypesDialog;
